<template>
    <div class="container-fluid">
      <iframe v-if="jsonStatic.url_iframe_dashboard" width="100%" height="100%" :src="jsonStatic.url_iframe_dashboard"></iframe>
    </div>   
</template>
<script>
export default {
  name: 'Dashboard',
  computed: {
    jsonStatic: function () {
      return this.$store.state.jsonStatic
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/views/Dashboard.vue